import {formatOrderMoney} from "../orders/order-money";

export const appliedCartDiscount = row => Math.max(Number(row.discount) || 0, Number(row.couponDiscount) || 0);

export function cartUnitPrice(row) {
    if (row.effectiveUnitPrice !== null && row.effectiveUnitPrice !== undefined) {
        return Number(row.effectiveUnitPrice);
    }
    return Number(row.price) * (1 - appliedCartDiscount(row) / 100);
}

export function cartLineTotal(row, quantity) {
    // Match the service's decimal HALF_UP rounding once per extended line.
    const [mantissa, exponent = "0"] = String(row.effectiveUnitPrice ?? cartUnitPrice(row)).toLowerCase().split("e");
    const [whole, fraction = ""] = mantissa.split(".");
    if (!/^\d+$/.test(whole + fraction) || !Number.isSafeInteger(Number(quantity)) || Number(quantity) < 0) {
        return NaN;
    }
    const scale = fraction.length - Number(exponent);
    const divisor = BigInt("1" + "0".repeat(Math.max(0, scale)));
    const numerator = BigInt(whole + fraction) * BigInt(quantity) * BigInt(100) * BigInt("1" + "0".repeat(Math.max(0, -scale)));
    const cents = numerator / divisor + (numerator % divisor * BigInt(2) >= divisor ? BigInt(1) : BigInt(0));
    return Number(cents) / 100;
}

export function cartTotalsLabel(items, counts = {}) {
    const totals = new Map();
    items.forEach(item => {
        const currency = item.currency || null;
        totals.set(currency, (totals.get(currency) || 0) + cartLineTotal(item, counts[item.cartId] ?? item.quantity));
    });
    return [...totals].map(([currency, total]) => formatOrderMoney(total, currency)).join(" · ");
}
